<template>
  <div class="wrapper-page animated fadeInDown">
    <div class="panel panel-color panel-primary">
      <div class="panel-heading">
        <h3 class="text-center m-t-10"><strong>Register</strong></h3>
      </div>

      <form
        class="form-horizontal m-t-40"
        method="POST"
        @submit.prevent="register"
      >
        <div
          v-if="$store.state.alert != null"
          class="alert animated bounceInDown"
          :class="'alert-' + $store.state.alert.status || ''"
          role="alert"
        >
          <span v-html="$store.state.alert.message"></span>
          <button
            type="button"
            class="close"
            v-if="$store.state.alert.dismissable || true"
            @click="$store.commit('showAlert', null)"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="form-group" :class="{ 'has-error': errors.first_name }">
          <div class="col-xs-12">
            <input
              class="form-control"
              type="text"
              placeholder="First Name"
              name="first_name"
              required
              autocomplete="name"
              autofocus
              v-model="first_name"
            />
            <span class="help-block" role="alert" v-if="errors.first_name">
              <strong>{{ errors.first_name[0] }}</strong>
            </span>
          </div>
        </div>

        <div class="form-group" :class="{ 'has-error': errors.last_name }">
          <div class="col-xs-12">
            <input
              class="form-control"
              type="text"
              placeholder="Last Name"
              name="last_name"
              required
              autocomplete="name"
              autofocus
              v-model="last_name"
            />
            <span class="help-block" role="alert" v-if="errors.last_name">
              <strong>{{ errors.last_name[0] }}</strong>
            </span>
          </div>
        </div>

        <div class="form-group" :class="{ 'has-error': errors.email }">
          <div class="col-xs-12">
            <input
              class="form-control"
              type="email"
              placeholder="Email Address"
              name="email"
              required
              autocomplete="email"
              autofocus
              v-model="email"
            />
            <span class="help-block" role="alert" v-if="errors.email">
              <strong>{{ errors.email[0] }}</strong>
            </span>
          </div>
        </div>

        <div class="form-group" :class="{ 'has-error': errors.password }">
          <div class="col-xs-12">
            <input
              class="form-control"
              type="password"
              name="password"
              placeholder="Password"
              required
              autocomplete="new-password"
              v-model="password"
            />
            <span class="help-block" role="alert" v-if="errors.password">
              <strong>{{ errors.password[0] }}</strong>
            </span>
          </div>
        </div>

        <div
          class="form-group"
          :class="{ 'has-error': errors.password_confirmation }"
        >
          <div class="col-xs-12">
            <input
              class="form-control "
              type="password"
              name="password_confirmation"
              placeholder="Confirm Password"
              required
              autocomplete="new-password"
              v-model="password_confirmation"
            />
            <span
              class="help-block"
              role="alert"
              v-if="errors.password_confirmation"
            >
              <strong>{{ errors.password_confirmation[0] }}</strong>
            </span>
          </div>
        </div>

        <div class="form-group text-right">
          <div class="col-xs-12">
            <button class="btn btn-purple w-md" type="submit">
              Register
            </button>
          </div>
        </div>

        <div class="form-group m-t-30">
          <div class="col-sm-12 text-center">
            <a href="/login">Already have account?</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Register",
  data() {
    return {
      email: "",
      password: "",
      password_confirmation: "",
      last_name: "",
      first_name: "",
      errors: []
    };
  },

  methods: {
    register() {
      axios
        .post("/register", {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation
        })
        .then(response => {
          this.$store.commit("showAlert", {
            message: response.data.message || "Welcome aboard",
            status: "success"
          });
          this.first_name = "";
          this.last_name = "";
          this.email = "";
          this.password = "";
          this.password_confirmation = "";
        })
        .catch(error => {
          this.errors = error.response.data.errors || [];
          this.$store.commit("showAlert", {
            message: error.response.data.message || "Could not Login",
            status: "danger"
          });
        });
    }
  },

  mounted() {}
};
</script>
